import React from 'react'

export const AssignLeadListLayer = () => {
  return (
    <div>AssignLeadListLayer</div>
  )
}
